import type { SceneTemplateReferenceMap } from '@lumen5/luminary';

/* ACTION TYPES */
export enum COLOR_SHUFFLE_ACTIONS {
    SET_SLIDE_COLOR_SHUFFLE_DATA = 'SET_SLIDE_COLOR_SHUFFLE_DATA',
    SET_SLIDE_COLOR_SHUFFLE_INDEX = 'SET_SLIDE_COLOR_SHUFFLE_INDEX',
    SET_TEMPLATE_COLOR_SHUFFLE_PALETTES = 'SET_TEMPLATE_COLOR_SHUFFLE_PALETTES',
    SET_TEMPLATE_COLOR_SHUFFLE_INDEX = 'SET_TEMPLATE_COLOR_SHUFFLE_INDEX',
}

/**
 * Info necessary for color shuffling, for example:
 * {
 *  // an array of arrays of integers, one integer for each color in template.colors. For a 4-color palette
 *   colorShuffles: [
 *        [0, 1, 2, 3]
 *        [1, 2, 0, 3]
 *        [3, 0, 2, 1]
 *    ...
 *   ],
 *   // a mapping from child element names to color property names
 *   childColorProps:
 *   {
 *        'text_1': ['normalStyle.fill', 'colorGraphics.${index}.shape.fillColor', 'highlightStyle.fill'],
 *        'color_1': ['sourceColor', 'sourceAlpha'],
 *        ....
 *   },
 *   // a luminary templateReferenceMap that captures the original state of the slide before any color swapping was applied
 *   templateReferenceMap: {SceneTemplateReferenceMap}
 * }
 */
export type ColorShuffleInfo = {
    colorShuffles: number[][];
    childColorProps: Record<string, Set<string>>;
    templateReferenceMap: SceneTemplateReferenceMap;
};
